import { useMutation } from 'react-query'
import axios from 'axios'
import queryString from 'query-string'

type dataType = {
  project_uid: string
  serial_number: string
}
export const useRunTest = (parameters: dataType) => {
  return useMutation(
    ['active', parameters.project_uid, parameters.serial_number],
    async () => {
      const params = queryString.stringify(parameters)

      try {
        const result = await axios.get(
          `https://api-signaltest.colonynetworks.com/v4/signaltest/run?${params}`
        )

        return result.data
      } catch (error) {
        throw new Error('Failed running test')
      }
    }
  )
}
